import ActionTypes from './ActionTypes';

export interface State {
	request: Promise<any> | null;
}

type Action =
	| { type: 'PasswordReset.request'; request: Promise<any> }
	| { type: 'PasswordReset.receive'; request: Promise<any> };

function createState(): State {
	return {
		request: null,
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.request:
			return { ...state, request: action.request };

		case ActionTypes.receive:
			return state.request === action.request ? { ...state, request: null } : state;

		default:
			return state;
	}
}
